module.exports = __webpack_public_path__ + "img/Calendar.2923ffc1.svg";